// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // apiBaseUrl: "http://localhost:3000",
  // apiBaseUrl: "http://192.168.50.99:3000",
  // apiBaseUrl:"https://api-staging.farstay.in",
    // apiBaseUrl:"https://api.farstay.in",

  apiBaseUrl: "https://api-farstay.ipixsolutions.net",
  appClientId: "2",
  production: false,
};
/*
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
